import 'flag-icon-css/css/flag-icon.css'


//////////////////
// WEBPACK FOOTER
// ./~/vue-flag-icon/vendors/index.js
// module id = 384
// module chunks = 11